import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { Auth0Error, Auth0User } from 'modules/auth/types/auth0'
import { postUser, PostUserProps } from '../api/postUser'

interface Props {
  mutationOptions?: UseMutationOptions<
    Auth0User,
    AxiosError<Auth0Error>,
    PostUserProps
  >
}

export const usePostUserMutation = ({ mutationOptions }: Props = {}) => {
  return useMutation<Auth0User, AxiosError<Auth0Error>, PostUserProps>({
    mutationFn: postUser,
    ...mutationOptions,
  })
}
